import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const PrivacyPolicyPage = () => {
    return (
        <div className="min-h-screen bg-black text-white font-sans pt-24 pb-12">
            <SEO
                title="Privacy Policy - Qivra Technologies"
                description="Privacy Policy for Qivra Technologies. Learn how we collect, use, and protect your data."
                keywords="privacy policy, data protection, qivra technologies privacy"
            />
            <div className="max-w-4xl mx-auto px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent mb-8">
                        Privacy Policy
                    </h1>
                    <p className="text-gray-400 mb-8">Last Updated: January 30, 2026</p>

                    <div className="space-y-8 text-gray-300 leading-relaxed">
                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">1. Introduction</h2>
                            <p>
                                At Qivra Technologies ("we", "our", or "us"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">2. Operations in India</h2>
                            <p>
                                Qivra Technologies operates within the jurisdiction of India. By accessing our services, you acknowledge and agree that your data may be processed and stored in accordance with Indian laws and regulations, including the Information Technology Act, 2000, and its applicable rules.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">3. Information We Collect</h2>
                            <ul className="list-disc pl-5 space-y-2">
                                <li><strong>Personal Data:</strong> Name, email address, phone number, company name, and other contact details you voluntarily provide.</li>
                                <li><strong>Usage Data:</strong> IP address, browser type, operating system, page views, and other analytics data collected via cookies and tracking technologies.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">4. How We Use Your Information</h2>
                            <p>We use your information to:</p>
                            <ul className="list-disc pl-5 space-y-2 mt-2">
                                <li>Provide, operate, and maintain our services.</li>
                                <li>Improve user experience and personalize content.</li>
                                <li>Communicate with you regarding updates, offers, and support.</li>
                                <li>Analyze website traffic and usage patterns.</li>
                                <li>Comply with legal obligations.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">5. Data Sharing & Disclosure</h2>
                            <p>
                                We do not sell your personal data. We may share information with trusted third-party service providers (e.g., analytics, hosting) who assist us in operating our business, provided they agree to keep your information confidential. We may also disclose data if required by law or to protect our rights.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">6. Data Security</h2>
                            <p>
                                We implement robust security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">7. Your Rights</h2>
                            <p>
                                Depending on your location, you may have the right to access, correct, delete, or restrict the use of your personal data. Contact us to exercise these rights.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">8. Contact Us</h2>
                            <p>
                                If you have any questions about this Privacy Policy, please contact us at:
                                <br />
                                <a href="mailto:contact@qivratech.com" className="text-cyan-400 hover:text-cyan-300">contact@qivratech.com</a>
                            </p>
                        </section>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
